var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 181,
    viewBox: "0 0 173 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.05 96.7292C37.46 93.1393 37.46 87.3292 41.05 83.7492L111.96 12.8392C112.35 12.4292 112.6 11.8792 112.6 11.2692C112.6 10.6492 112.35 10.0992 111.95 9.68925C111.34 9.13925 110.71 8.61925 110.07 8.11925C95.03 -3.66075 73.22 -2.62075 59.37 11.2292L13.89 56.6992C-4.63 75.2192 -4.63 105.249 13.89 123.779L42.53 152.419C43.43 153.319 44.88 153.319 45.78 152.419L69.64 128.559C70.54 127.659 70.54 126.209 69.64 125.309L41.05 96.7292Z",
    fill: "#14DA72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.89 83.7493C135.48 87.3393 135.48 93.1493 131.89 96.7293L60.9801 167.639C60.5901 168.049 60.3401 168.599 60.3401 169.209C60.3401 169.829 60.5901 170.379 60.9901 170.789C61.6001 171.339 62.2301 171.859 62.8701 172.359C77.9101 184.139 99.7201 183.099 113.57 169.249L159.05 123.769C177.57 105.249 177.57 75.2193 159.05 56.6893L130.41 28.0493C129.51 27.1493 128.06 27.1493 127.16 28.0493L103.3 51.9093C102.4 52.8093 102.4 54.2593 103.3 55.1593L131.89 83.7493Z",
    fill: "#14DA72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLink);
export default __webpack_public_path__ + "static/media/LogoLink.af606ff7.svg";
export { ForwardRef as ReactComponent };